// extracted by mini-css-extract-plugin
module.exports = {"root":"root___piXfE","hide":"hide___2u1xW","text":"text___3_6wC","loading":"loading___1oFrY"};